/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */


(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatentrychooser', {
      restrict: 'E',
      bindings: {
        privcatentries: '<?'
      },
      template: `
          <div class="row">
              <div class="col-xs-12 col-md-4" ng-repeat="entry in vm.privcatentries">
              <span class="btn btn-success btn-xs" 
                    uib-tooltip="Leistungen hinzufügen"
                    ng-click="vm.addServiceOrGroup(entry)"><i class="fa fa-upload"></i>&nbsp;{{entry.name}}</span>
              </div>
          </div>
        
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
          let vm = this;
          vm.addServiceOrGroup = addServiceOrGroup;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.privcatentries)) {
              vm.privcatentries = Privcat.$search({type: 'entry', active: true});
            }
          }; // $onInit()


          function addServiceOrGroup(entry) {
            //  TODO fill out $http request, what to send / groupid per get, or group object per post?
          }

          vertxEventBusService.on('privcat.update', function (message) {
            $log.debug('debug: privcat update received: ', message);
            let messages = message.split(':');
            vm.privcatentries.$refresh().$then(function () {
              $log.debug('debug: privcatentrylist refreshed');
            }, function (error) {
              $log.debug('debug: privcatentrylist refresh failed: ', error);
            });
          });
          
          
          
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());